import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {computeYDomain} from "../computeYDomain";
import {GreaterThresholdMarker} from "./greaterThresholdMarker";
import {LesserThresholdMarker} from "./lesserThresholdMarker";
import {RangeThresholdMarker} from "./rangeThresholdMarker";

/** This component will check type of threshold and render threshold marker component accordingly for the array of thresholds passed. */

export const RenderThresholdMarkers = (props) => {
  const {data, thresholds, valueColumns} = props;

  const domains = computeYDomain(data, valueColumns);

  return (
    <Fragment>
      {thresholds.map((threshold, index) => {
        switch (threshold.type) {
          case "greater":
            return (
              <GreaterThresholdMarker
                domains={domains}
                key={index}
                threshold={threshold}
              />
            );
          case "lesser":
            return (
              <LesserThresholdMarker
                domains={domains}
                key={index}
                threshold={threshold}
              />
            );
          case "range":
            return (
              <RangeThresholdMarker domains={domains} key={index} threshold={threshold} />
            );
          default:
            throw new Error("Unknown threshold type in <ThresholdMarkers /> ");
        }
      })}
    </Fragment>
  );
};

RenderThresholdMarkers.propTypes = {
  data: PropTypes.array.isRequired,
  thresholds: PropTypes.array.isRequired,
  valueColumns: PropTypes.array.isRequired,
};
